"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsx } from 'react/jsx-runtime';
import { useComboBoxDropdownContext } from '../../context/use-combobox-dropdown.mjs';
import { DropdownCategoryType } from '../../shared.mjs';
import { DropdownUI } from '../../../DropdownUI/index.mjs';
import { OptionsList } from '../OptionsList.mjs';
import { LookupOptionsCategoryContent } from './LookupOptions/index.mjs';

function RootCategoryContent({ onOptionSelect }) {
  const { availableCategories } = useComboBoxDropdownContext();
  const optionsList = /* @__PURE__ */ jsx(OptionsList, { onOptionSelect });
  return /* @__PURE__ */ jsx(DropdownUI.Panel, { children: availableCategories?.includes(DropdownCategoryType.LOOKUP_OPTIONS) ? /* @__PURE__ */ jsx(LookupOptionsCategoryContent, { onOptionSelect, children: optionsList }) : /* @__PURE__ */ jsx(DropdownUI.List, { children: optionsList }) });
}

export { RootCategoryContent };
